
import Layout from './components/layout/Layout'
import './App.css'

function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  )
}

export default App 